/**
 * Publishes the *visual* viewport height as the `--app-height` CSS variable on
 * the document root.
 *
 * On mobile the on-screen keyboard shrinks the visual viewport but NOT the
 * layout viewport — `vh`/`dvh` stay at full height on iOS. A full-height chat
 * layout sized in `dvh` therefore stays taller than the visible area when the
 * keyboard opens, so the browser scrolls the whole thing up to reveal the
 * focused input and the sticky header slides out of view.
 *
 * Sizing the chat layout to `var(--app-height)` instead keeps it pinned to the
 * visible area: the header stays, the composer sits just above the keyboard,
 * and the message list (not the window) is what scrolls. Works in the browser
 * and the native (Capacitor) shell alike; on desktop it just tracks
 * `innerHeight`, so it is a no-op there.
 */
export function initAppHeight(): void {
  if (typeof window === 'undefined') return;
  const root = document.documentElement;
  const vv = window.visualViewport;

  const apply = () => {
    const height = vv?.height ?? window.innerHeight;
    root.style.setProperty('--app-height', `${Math.round(height)}px`);
  };

  apply();

  if (vv) {
    vv.addEventListener('resize', apply);
    vv.addEventListener('scroll', apply);
  }
  window.addEventListener('resize', apply);
  window.addEventListener('orientationchange', apply);
}
